import {Application} from "../Application";
import {LevelNumber, MaxLevel, MinLevel} from "./LevelModel";
import {Location} from "./Location";
import {OnboardingStep} from "./OnboardingStep";

export class PersistentGameModel {

    public static getLocationLevel(location: Location) {
        let level = Application.instance.saveManager.readNumber(`location-level-${location}`);
        if (isNaN(level) || level < MinLevel || level > MaxLevel) {
            level = MinLevel;
        }
        return level as LevelNumber;
    }

    public static getNextLocationLevel(location: Location) {
        let level = Application.instance.saveManager.readNumber(`location-level-${location}`);
        if (isNaN(level) || level < MinLevel) {
            return MinLevel;
        }
        level += 1;
        if (level > MaxLevel) {
            level = MinLevel;
        }
        return level as LevelNumber;
    }

    public static completeLocationLevel(location: Location, level: LevelNumber) {
        Application.instance.saveManager.storeNumber(`location-level-${location}`, level);
        let completeLevels = Application.instance.saveManager.readString(`complete-levels`, "");
        const levelId = `${location}-${level}`;
        if (completeLevels.indexOf(levelId) < 0) {
            if (completeLevels) {
                completeLevels += ",";
            }
            completeLevels += levelId;
            Application.instance.saveManager.storeString(`complete-levels`, completeLevels);
        }
    }

    public static getFreePlayUnlocked() {
        const completeLevels = Application.instance.saveManager.readString(`complete-levels`);
        return completeLevels && completeLevels.split(",").length >= 5;
    }

    public static getFreePlayVisited() {
        return Application.instance.saveManager.readBool(`free-play-visited`);
    }

    public static setFreePlayVisited(value: boolean) {
        Application.instance.saveManager.storeBool(`free-play-visited`, true);
    }

    public static getLocationSelectVisited() {
        return Application.instance.saveManager.readBool(`location-select-visited`);
    }

    public static setLocationSelectVisited(value: boolean) {
        Application.instance.saveManager.storeBool(`location-select-visited`, true);
    }

    public static getOnboardingStep() {
        return Application.instance.saveManager.readNumber(`onboarding-step`, OnboardingStep.None) as OnboardingStep;
    }

    public static setOnboardingStep(value: OnboardingStep) {
        Application.instance.saveManager.storeNumber(`onboarding-step`, value);
    }
}
